/* istanbul ignore file */
import React from 'react';

function IconSearch() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "icon-search",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      width: 15
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeWidth: "20",
    fill: "#627691",
    d: "M9.1,20.1c-1.5-2.1-2.3-4.6-2.3-7.3c0-7,5.6-12.6,12.6-12.6\nS32,5.9,32,12.8s-5.6,12.6-12.6,12.6c-2.7,0-5.2-0.9-7.3-2.3l-8.3,8.3c-0.8,0.8-2.1,0.8-2.9,0l0,0c-0.8-0.8-0.8-2.1,0-2.9\nL9.1,20.1L9.1,20.1z M9.7,12.8c0,5.3,4.3,9.6,9.6,9.6s9.6-4.3,9.6-9.6s-4.3-9.6-9.6-9.6S9.7,7.5,9.7,12.8L9.7,12.8z"
  }));
}

export default IconSearch;